const debounce = <
    F extends (...params: T) => Promise<K> | void,
    // eslint-disable-next-line
    T extends any[],
    K,
>(
    fn: F,
    delay: number,
    leading?: boolean,
): DebouncedFn<F> => {
    let timeoutID: NodeJS.Timeout | null = null;

    const debouncedFunction = function (this: unknown, ...args: T) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async resolve => {
            if (timeoutID) {
                clearTimeout(timeoutID);
            }
            if (leading && !timeoutID) {
                const res = await fn.apply(this, args);
                resolve(res as K);
                timeoutID = setTimeout(() => {
                    timeoutID = null;
                }, delay);
            } else {
                timeoutID = setTimeout(async () => {
                    const res = await fn.apply(this, args);
                    resolve(res as K);
                    timeoutID = null;
                }, delay);
            }
        });
    } as DebouncedFn<F>;

    debouncedFunction.cancel = () => {
        if (timeoutID) {
            clearTimeout(timeoutID);
            timeoutID = null;
        }
    };

    return debouncedFunction;
};

export default debounce;

export type DebouncedFn<T> = T & {
    cancel: () => void;
};
